import { store, reviewStore, categoryStore } from '@/store';
// import { formatLandingPageText } from '@/helpers';
import { facebookMixin } from './facebook';
import { analyticsMixin } from './analytics';
import { partnersMixin } from './partners';
import { getCategory } from '@/services/top5-v2-1/get-category';
import { routeMixin } from './route';

export const categoryMixin = {
    data() {
        return {
            categoryState: categoryStore.state,
            loaded: false,
            showCount: [],
            psh: [],
            maxPartners: null,
            propNames: [],
        };
    },
    mixins: [facebookMixin, analyticsMixin, partnersMixin, routeMixin],
    mounted() {
        this.getCategory();
    },
    computed: {
        displayedPartners() {
            return this.categoryState?.rankingList || [];
        },
        activeOnlyPartners() {
            return this.categoryState?.rankingList?.filter(
                (partner) => !partner['is_disabled']
            );
        },
    },
    created() {
        this.$eventHub.$on('reload-partners', () => {
            this.reload();
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('reload-partners');
    },
    methods: {
        reload() {
            this.getCategory();
        },
        async getPaginatedRankingList() {
            const args = {
                category: this.getCategorySlug(),
                hasAbRank: Boolean(this.$route.query.arnk),
                fixedPosition: this.$globalState.fixedPosition,
                boostRankingVersion: this.$route.query.brnkv,
                boostRanking: this.$route.query.brnk,
                start: this.getInitialPartnerCount() + 1,
                length: this.categoryState.partnersCount,
            };
            const data = await getCategory(args);
            const updatedPartners = [
                ...categoryStore.state.rankingList,
                ...data.partners,
            ];
            categoryStore.updateRankingList(updatedPartners);
            categoryStore.setCategory(data.category);
        },
        getInitialPartnerCount() {
            let initialPartnerCount = 5;

            try {
                const partnerRowType =
                    window.__dyanmic_template_props__?.CategoryPage
                        ?.partnerRowType;

                if (partnerRowType === 'PartnerRowGamma') {
                    initialPartnerCount = 3;
                }
            } catch (error) {
                console.error(
                    'An error occurred while accessing partner row type:',
                    error
                );
            }

            return initialPartnerCount;
        },
        async getCategory() {
            categoryStore.state.isLoaded = false;

            if (window.__load_category__ && window.__load_category__ === true) {
                this.checkXMLHttpResponse();
            } else if (
                window.__partner_rankings__ &&
                Object.keys(window.__partner_rankings__).length > 0
            ) {
                this.processResponse(window.__partner_rankings__, true);
                window.__partner_rankings__ = null;
            } else {
                const category = this.getCategorySlug();
                const data = await getCategory({
                    category,
                    hasAbRank: Boolean(this.$route.query.arnk),
                    fixedPosition: this.$globalState.fixedPosition,
                    boostRankingVersion: this.$route.query.brnkv,
                    boostRanking: this.$route.query.brnk,
                    start: '1',
                    length: this.getInitialPartnerCount(),
                });

                this.processResponse(data);

                this.$eventHub.$emit('partner-list-loaded');
            }
        },
        checkXMLHttpResponse() {
            if (!window.__partner_rankings__) {
                let interval = setInterval(() => {
                    if (window.__partner_rankings__) {
                        this.processXMLHttpResponse(
                            window.__partner_rankings__
                        );
                        clearInterval(interval);
                    }
                }, 100);
            } else {
                this.processXMLHttpResponse(window.__partner_rankings__);
            }
        },
        processXMLHttpResponse(data) {
            window.__load_category__ = null;
            window.__partner_rankings__ = null;

            data = JSON.parse(data);
            data['bannerPartner'] =
                data['banner_partner'] || data['partners'][0];
            data['pageViewId'] = data['page_view_id'];
            data['partnersReview'] = data['partners_review'];
            data['partnersCount'] = data['partners_count'] || 0;
            data['homePageReview'] = data['home_page_review'];

            this.processResponse(data);
        },
        processResponse(data) {
            window.__sea_lp_category__ = data.partnerSet.sea_lp_category || '';
            this.categoryState.bannerPartner = data.bannerPartner;
            this.categoryState.sidebar_billboard_partner =
                data['sidebar_billboard_partner'] || [];
            categoryStore.setCategory(data.category);
            store.setPsh(data.partnerSet);
            store.setPageViewId(data.pageViewId);
            reviewStore.setReviewPartners(data.partnersReview);
            categoryStore.updateRankingList(data.partners);

            this.handleAnalyticalEvents(data);
            categoryStore.setPartnersCount(data.partnersCount);

            // document.title = data.category.title
            //     ? formatLandingPageText(data.category.title)
            //     : this.$globalConstants.host['name'];
            // document
            //     .querySelector('meta[name="description"]')
            //     ?.setAttribute(
            //         'content',
            //         this.categoryState.category.description
            //     );
            categoryStore.state.isLoaded = true;

            if (window.track) {
                const category = this.getCategorySlug();
                window.track.pageview(`/${category}`);
            }
        },
        handleAnalyticalEvents(data) {
            // handle provider level content events
            if (data?.ab_content_test) {
                const contentTest = data?.ab_content_test || {};
                window.track.event({
                    event: 'Provider Content Variant',
                    provider_content_variant: contentTest['variant']
                        ? 'content test ' + contentTest['variant'].toLowerCase()
                        : '',
                    provider_content_test_name: contentTest['name'] || '',
                });
            }

            // handle partner set hash events
            if (!data['partnerSet']) return;
            let brVersion = null;
            const partnerSetHash = data['partnerSet'];

            if (
                Boolean(partnerSetHash.ranking_source) &&
                partnerSetHash.ranking_source.includes('boostrank')
            ) {
                brVersion = 'default';
            }

            if (partnerSetHash.br_version) {
                brVersion = 'variant';
            }

            if (window.track && Boolean(brVersion)) {
                window.track.event({
                    event: 'Br Version',
                    br_version: brVersion,
                });
            } else {
                window.track.event({
                    event: 'Br Version',
                    br_version: null,
                });
            }

            let rankingSourceAbTest = null;
            if (partnerSetHash.ab_test) {
                rankingSourceAbTest = 'baseline';
            }

            if (
                Boolean(partnerSetHash.ab_test) &&
                Boolean(partnerSetHash.rswinner)
            ) {
                // convert alphabet to integer
                let index = partnerSetHash.rswinner.charCodeAt(0) - 97;
                if (index === 0) {
                    rankingSourceAbTest = 'baseline';
                }
                if (index === 1) {
                    rankingSourceAbTest = 'variant';
                }
                if (index > 1) {
                    rankingSourceAbTest = 'variant ' + index;
                }
            }

            if (window.track && Boolean(rankingSourceAbTest)) {
                window.track.event({
                    event: 'Ranking Variant',
                    ranking_variant: rankingSourceAbTest,
                });
            } else {
                window.track.event({ ranking_variant: null });
            }
        },
    },
};
